"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getBlockForIndex_1 = __importDefault(require("./getBlockForIndex"));

function getBlocksForRange(value, start, end) {
  var firstBlock = getBlockForIndex_1.default(value, start);
  var blocks = [firstBlock];
  var firstBlockKey = firstBlock != null && firstBlock.block != null && firstBlock.block.blockKey;
  return value.slice(start, end).reduce(function (acc, ch, index) {
    if (ch.type === 'block-start' && ch.blockKey !== firstBlockKey) {
      return acc.concat({
        blockOffset: start + index,
        block: ch
      });
    }

    return acc;
  }, blocks);
}

exports.default = getBlocksForRange;